import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1ca9ce22")

_pushScopeId("data-v-1ca9ce22")
const _hoisted_1 = { class: "skills-section section py-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", { class: "section-title font-weight-bold text-center mb-3" }, " Skills Overview ", -1)
const _hoisted_4 = { class: "skills-blocks mx-auto pt-5" }
const _hoisted_5 = { class: "row" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SkillsBlock = _resolveComponent("SkillsBlock")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_SkillsBlock, {
            class: "manual-testing",
            "group-name": "Manual Testing",
            skills: [
              'Preparing tests plans',
              'Creating scenarios',
              'Bugs raporting',
              'Regression testing',
              'XRay / qTest',
            ],
            icon: "/images/manual-testing.svg"
          }),
          _createVNode(_component_SkillsBlock, {
            class: "automated-testing",
            "group-name": "Automated Testing",
            skills: [
              'Cypress / CodeceptJS / Protractor',
              'Selenium / WebDriver',
              'Cucumber / BDD',
              'BrowserStack / Sauce Labs',
              'Page Object Pattern',
            ],
            icon: "/images/automated-testing.svg"
          }),
          _createVNode(_component_SkillsBlock, {
            "group-name": "Tools",
            skills: [
              'Git CLI',
              'GitHub / Bitbucket / GitLab',
              'Chrome Dev Tools / XPath',
              'Postman / cURL',
              'JS / HTML5 / CSS3 / Bootstrap',
            ],
            icon: "/images/other-skills-icon.svg"
          })
        ])
      ])
    ])
  ]))
})